'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _framework7React = require('framework7-react');

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bottomElementSlideTransition = {
  'WebkitTransition': 'height 0.5s linear',
  'MozTransition': 'height 0.5s linear',
  'msTransition': 'height 0.5s linear',
  'OTransition': 'height 0.5s linear',
  'transition': 'height 0.5s linear'
};

var styles = {
  bottomPositionedElementParent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    position: 'relative',
    overflow: 'hidden'
  },
  content: {
    height: '100%',
    overflowY: 'scroll'
  },
  bottomElement: _extends({
    position: 'absolute',
    bottom: 0,
    width: '100%'
  }, bottomElementSlideTransition),
  bottomElementHidden: _extends({
    height: 0
  }, bottomElementSlideTransition)
};

var resizeEventListenerRegistered = false;
var formFullHeight = void 0;
var checkPageSize = function checkPageSize(callback) {
  var form = document.getElementsByClassName('arreeba-form_content')[0];
  if (form) {
    var formCurrentHeight = form.offsetHeight;
    var shouldHide = formCurrentHeight < formFullHeight;
    console.log('resize', formCurrentHeight, shouldHide);
    callback(shouldHide);
  } else {
    console.log('form removed from page?');
  }
};

var resizeEventListener = checkPageSize;

var setResizeEventListener = function setResizeEventListener(callback) {
  if (!resizeEventListenerRegistered) {
    resizeEventListenerRegistered = true;
    var form = document.getElementsByClassName('arreeba-form_content')[0];
    formFullHeight = form.offsetHeight;
    var onResize = function onResize() {
      return resizeEventListener(callback);
    };
    window.removeEventListener('resize', onResize);
    window.addEventListener('resize', onResize, true);
  }
};

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.state = {};
    _this.toggleTopElementVisibility = _this.toggleTopElementVisibility.bind(_this);
    _this.toggleBottomElementVisibility = _this.toggleBottomElementVisibility.bind(_this);
    return _this;
  }

  _createClass(Form, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.bottomElement) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ bottomElementHeight: this.bottomElement.offsetHeight });
      }

      setResizeEventListener(function (shouldHide) {
        _this2.toggleTopElementVisibility(shouldHide);
        _this2.toggleBottomElementVisibility(shouldHide);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', resizeEventListener);
    }
  }, {
    key: 'toggleTopElementVisibility',
    value: function toggleTopElementVisibility(shouldHideTopElement) {
      if (typeof shouldHideTopElement === 'boolean') {
        this.setState({ shouldHideTopElement: shouldHideTopElement });
        return;
      }
      this.setState({ shouldHideTopElement: !this.state.shouldHideTopElement });
    }
  }, {
    key: 'toggleBottomElementVisibility',
    value: function toggleBottomElementVisibility(shouldHideBottomElement) {
      if (typeof shouldHideBottomElement === 'boolean') {
        this.setState({ shouldHideBottomElement: shouldHideBottomElement });
        return;
      }
      this.setState({ shouldHideBottomElement: !this.state.shouldHideBottomElement });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          formTitle = _props.formTitle,
          topElement = _props.topElement,
          bottomElement = _props.bottomElement,
          submitClassNames = _props.submitClassNames,
          onCancel = _props.onCancel,
          onSubmit = _props.onSubmit,
          submitButtonLabel = _props.submitButtonLabel,
          cancelButtonLabel = _props.cancelButtonLabel,
          framework7AppContext = _props.framework7AppContext;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'div',
          {
            ref: function ref(c) {
              _this3.form = c;
            },
            className: 'arreeba-form_content',
            style: _extends({}, styles.content, {
              marginBottom: this.state.shouldHideBottomElement ? 0 : this.state.bottomElementHeight + 'px'
            })
          },
          !this.state.shouldHideTopElement && topElement,
          formTitle && _react2.default.createElement(
            _framework7React.ContentBlockTitle,
            null,
            formTitle
          ),
          _react2.default.createElement(
            _framework7React.List,
            { inset: this.props.inset, form: true, id: 'this-form' },
            children
          )
        ),
        _react2.default.createElement(
          'div',
          {
            ref: function ref(c) {
              _this3.bottomElement = c;
            },
            className: 'arreeba-form_bottomElement',
            style: _extends({}, this.state.shouldHideBottomElement ? styles.bottomElementHidden : styles.bottomElement)
          },
          bottomElement,
          onCancel && _react2.default.createElement(
            _.Button,
            {
              big: true,
              raised: true // material
              , onClick: onCancel,
              style: styles.cancelButton
            },
            cancelButtonLabel
          ),
          onSubmit && _react2.default.createElement(
            _.Button,
            {
              big: true,
              active: true // ios
              , raised: true // material
              , fill: true // material
              , className: submitClassNames,
              onClick: function onClick() {
                framework7AppContext.getFramework7(function (f7) {
                  onSubmit(f7.formToData('#this-form'));
                });
              },
              style: styles.submitButton
            },
            submitButtonLabel
          )
        )
      );
    }
  }]);

  return Form;
}(_react.Component);

;

Form.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  formTitle: _propTypes2.default.string,
  cancelButtonLabel: _propTypes2.default.string,
  submitButtonLabel: _propTypes2.default.string.isRequired,
  onCancel: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  topElement: _propTypes2.default.object,
  bottomElement: _propTypes2.default.object,
  buttonsAtTheBottom: _propTypes2.default.bool,
  submitClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Form.defaultProps = {
  inset: false
};

exports.Form = Form;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components-framework7/Form.js
// module id = 286
// module chunks = 0